import React from 'react';

/**
 * OAuth scopes used for Okta tokens.
 */ const SCOPES = [
    'openid',
    'email',
    'profile',
    'groups',
    'offline_access'
];
/**
 * OAuth scopes used for Okta tokens (for command-line authentication).
 * Command-line authentication does not request the `offline_access` scope because we do not want
 * to return a refresh token for command line tokens.
 */ const CLI_SCOPES = [
    'openid',
    'email',
    'profile',
    'groups'
];
/**
 * Name of the cookie set in the UI at the beginning of the auth flow with a nonce value (i.e. random string) which
 * the backend later verifies at the end of the login flow.
 */ const NONCE_COOKIE_NAME = 'chrono-auth-nonce';
const AuthenticationContext = /*#__PURE__*/ React.createContext({
    isLoading: false,
    config: undefined,
    oktaClient: undefined,
    oktaImpersonateClient: undefined,
    oktaCliClient: undefined,
    oktaCliImpersonateClient: undefined,
    currentUser: undefined,
    refreshCurrentUser: undefined
});

export { AuthenticationContext, CLI_SCOPES, NONCE_COOKIE_NAME, SCOPES };
//# sourceMappingURL=AuthenticationContext.js.map
